import React, { useEffect, useState, useContext} from 'react'
import { sidebarContext } from '../../App'
import axios from 'axios'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'

export default function AdminDashboard() {
  const token = localStorage.getItem('token')
  const {setHS} = useContext(sidebarContext)
  const [data, setData] = useState({})

  useEffect(() => {
    setHS(0)
  },[setHS])

  // const fetchDashboardData = async() => {
  //   try{
  //     const res = await axios.get(`${config.baseurl}admin_dashboard/`,{
  //       headers:{
  //         'Authorization':`Token ${token}`
  //       }
  //     })

  //     if(res.status===200){
  //       setData(res.data.data)
  //     }else{
  //       toast.error('Failed to fetch data')
  //     }
  //   }catch(error){
  //     toast.error('Failed to fetch data')
  //   }
  // }  

  // useEffect(() => {
  //   fetchDashboardData()
  // },[token])

  return (
    <div className='min-h-screen bg-gradient-to-tr from-blue-100 via-white to-blue-100 ml-64 5xl:ml-0 justify-between items-center'>
      <AdminHeader/>

      <div className='pt-24 px-6 max-w-7xl mx-auto'>
        <div className='mb-10 text-center'>
          <h1 className='text-3xl font-bold mb-2 uppercase'>Admin Dashboard</h1>
        </div>
      </div>
    </div>
  )
}
